import { c as _slicedToArray } from './_rollupPluginBabelHelpers-fb970440.js';
import React, { useState, useEffect } from 'react';

var OTPTimer = function OTPTimer(_ref) {
  var duration = _ref.duration,
      setResendEnable = _ref.setResendEnable;

  var _useState = useState(duration),
      _useState2 = _slicedToArray(_useState, 2),
      timer = _useState2[0],
      setTimer = _useState2[1];

  useEffect(function () {
    var intervalId;

    var startTimer = function startTimer() {
      intervalId = setInterval(function () {
        setTimer(function (prevTimer) {
          if (prevTimer === 0) {
            // Timer reached zero, invoke the callback
            clearInterval(intervalId); // onTimeout();

            setResendEnable(true);
            return 0;
          }

          return prevTimer - 1;
        });
      }, 1000);
    };

    startTimer();
    return function () {
      return clearInterval(intervalId);
    };
  }, [duration]);
  return /*#__PURE__*/React.createElement("div", null, timer, " seconds left for Resend OTP button to enable");
};

export { OTPTimer as O };
